import { render, staticRenderFns } from "./ConfirmChangeStep.vue?vue&type=template&id=d1404b72&"
import script from "./ConfirmChangeStep.vue?vue&type=script&lang=js&"
export * from "./ConfirmChangeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports